// GWAS p-value presentation. Live-verified 2026-08-29: P_VALUE is a MySQL double (5.4e-21 stores
// fine), so the NUMBER is rendered — p_value_text is a sub-phenotype annotation ("NA" on ~75% of rows).

const P_VALUE_FLOOR = "<1e-300";

/** Exponent-formatted p-value ("3.1e-14"), the floor string for an underflowed zero, or null when null/blank/non-numeric. */
export const formatPValue = (raw: string | number | null | undefined): string | null => {
	if (raw === null || raw === undefined) return null;
	const text = String(raw).trim();
	if (text === "") return null;
	const value = Number(text);
	if (!Number.isFinite(value)) return null;
	// An exact zero is a double UNDERFLOW, not an absent effect — these rows are the corpus's strongest evidence.
	if (value === 0) return P_VALUE_FLOOR;
	// Two-digit mantissa with trailing zeros stripped: 3.1e-14, 1e-7, 5e-2.
	return value.toExponential(2).replace(/\.?0+e/, "e");
};

/** p_value_text as the sub-phenotype line it actually is — null when absent or the "NA" filler. */
export const subPhenotypeFrom = (raw: string | null | undefined): string | null => {
	if (typeof raw !== "string") return null;
	const text = raw.trim();
	if (text === "" || text.toUpperCase() === "NA") return null;
	return text;
};
